import React, { useState, useEffect } from 'react';
import { useBranch } from '../../../layouts/BranchContext';
import {
  // existing imports...
  CircularProgress,
} from "@mui/material";
import {
  styled,
  Button,
  TextField,
  Tooltip,
  Container,
  Typography,
  InputAdornment,
  Box,
  Table,
  Modal,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Employee = () => {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const { selectedBranchId, branchList, isMainBranchAdmin } = useBranch();

  // ✅ FIX: organization_id comes from the "client" key in localStorage
  // ✅ FIX: organization_id comes from "client" key in localStorage (not "user" — that key is null)
  // Kept for any future use; actual fetch uses clientData inside useEffect
  const clientData = JSON.parse(localStorage.getItem("client"));
  const getStoredUser = () => {
  try {
    return JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );
  } catch {
    return {};
  }
};

  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 20, 30];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportType, setExportType] = useState('active');
  const [importFile, setImportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [downloadingTemplate, setDownloadingTemplate] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const [showEditEmployeeModal, setShowEditEmployeeModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalType, setSuccessModalType] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [formData, setFormData] = useState({
    employeeCode: '',
    employeeName: '',
    dateOfBirth: '',
    dateOfJoining: '',
    gender: '',
    mobileNo: '',
    alternateNo: '',
    email: '',
    department: '',
    designation: '',
    country: '',
    state: '',
    city: '',
    maritalStatus: '',
  });

  const [employees, setEmployees] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const staticCountryData = [{ countryId: 6, countryName: 'India' }];
  const staticStateData = [
    { stateId: 9, stateName: 'Bihar' },
    { stateId: 10, stateName: 'Jharkhand' },
  ];
  const staticCityData = [
    { cityId: 8, cityName: 'Patna' },
    { cityId: 9, cityName: 'Ranchi' },
  ];
  const staticDepartmentData = [
    { departmentId: 5, departmentName: 'HR' },
    { departmentId: 6, departmentName: 'Finance' },
  ];
  const staticDesignationData = [
    { designationId: 4, designationName: 'Manager' },
    { designationId: 5, designationName: 'Developer' },
  ];
  const staticMaritalStatusData = [
    { statusId: 1, statusName: 'Single' },
    { statusId: 2, statusName: 'Married' },
    { statusId: 3, statusName: 'Divorced' },
  ];

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
          navigate("/login");
          return;
        }
        const [departmentsRes, designationsRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/master/departments/`, {
            headers: {
              'Authorization': `Bearer ${accessToken}`,
            },
          }),
          axios.get(`${API_BASE_URL}/api/master/designations/`, {
            headers: {
              'Authorization': `Bearer ${accessToken}`,
            },
          }),
        ]);
        setDepartments(departmentsRes.data);
        setDesignations(designationsRes.data);
      } catch (error) {
        console.error('Error fetching master data:', error);
        setSnackbarMessage('Failed to fetch master data');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      }
    };
    fetchMasterData();
  }, []);

  // ✅ FIX: On load, auto-select the branch from JWT token if available,
  // otherwise fall back to first branch of the organization.
  // Remaining branches are shown in dropdown and clicking switches data.
  // ✅ FIX: Auto-select is now handled directly inside fetchBranches above
  // after branches are fetched, using sessionStorage branch_id for regular users
  // and client.id org match for super admin — removed separate useEffect to avoid
  // branches[0] wrong-branch selection race condition

useEffect(() => {
  const fetchEmployees = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        navigate("/login");
        return;
      }

      const user = getStoredUser();
      const organization_id = user?.organization_id || clientData?.id;

      // Use selectedBranchId from context
      const url = organization_id && selectedBranchId
        ? `${API_BASE_URL}/api/staff/employees/filter/?organization_id=${organization_id}&branch_id=${selectedBranchId}`
        : `${API_BASE_URL}/api/staff/employees/`;

      const response = await axios.get(url, {
        headers: { 'Authorization': `Bearer ${accessToken}` },
      });

      // Rest of the function remains the same
      const data = response.data.results || response.data;
      const formattedData = data.map(emp => ({
        employeeID: emp.id,
        employeeCode: emp.employee_code,
        employeeName: emp.name,
        mobileNo: emp.mobile,
        emailID: emp.email,
        departmentName: emp.department_name || departments.find(dept => dept.id === emp.department)?.name || 'Unknown',
        designationName: emp.designation_name || designations.find(desig => desig.id === emp.designation)?.name || 'Unknown',
        joinDate: emp.date_of_joining,
        dateOfBirth: emp.dob,
        gender: emp.gender,
        alternateNo: emp.phone,
        country: emp.country_name || staticCountryData.find(country => country.countryId === emp.country)?.countryName || 'Unknown',
        state: emp.state_name || staticStateData.find(state => state.stateId === emp.state)?.stateName || 'Unknown',
        city: emp.city_name || staticCityData.find(city => city.cityId === emp.city)?.cityName || 'Unknown',
        maritalStatus: emp.marital_status,
      }));

      setEmployees(formattedData);
      setFilteredData(formattedData);
      setPage(1);
    } catch (error) {
      console.error('Error fetching employees:', error);
      setSnackbarMessage('Failed to fetch employees');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  fetchEmployees();
}, [departments, designations, selectedBranchId]); // Update dependency to selectedBranchId 

  useEffect(() => {
    setFilteredData(
      employees.filter(
        (employee) =>
          employee.employeeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          employee.departmentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          employee.designationName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, employees]);

  const handleAddEmployee = () => {
    setFormData({
      employeeCode: '',
      employeeName: '',
      dateOfBirth: '',
      dateOfJoining: '',
      gender: '',
      mobileNo: '',
      alternateNo: '',
      email: '',
      department: '',
      designation: '',
      country: '',
      state: '',
      city: '',
      maritalStatus: '',
    });
    setShowAddEmployeeModal(true);
  };

  const handleEdit = (employee) => {
    setSelectedEmployee(employee);
    setFormData({
      employeeCode: employee.employeeCode,
      employeeName: employee.employeeName,
      dateOfBirth: employee.dateOfBirth || '',
      dateOfJoining: employee.joinDate,
      gender: employee.gender || '',
      mobileNo: employee.mobileNo,
      alternateNo: employee.alternateNo || '',
      email: employee.emailID,
      department: employee.departmentName,
      designation: employee.designationName,
      country: employee.country || '',
      state: employee.state || '',
      city: employee.city || '',
      maritalStatus: employee.maritalStatus || '',
    });
    setShowEditEmployeeModal(true);
  };

  const handleShowDeleteModal = (employee) => {
    setSelectedEmployee(employee);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        navigate("/login");
        return;
      }

      // Call the DELETE API
      await axios.delete(`${API_BASE_URL}/api/staff/employees/${selectedEmployee.employeeID}/`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      // Remove employee from local state
      setEmployees((prevEmployees) =>
        prevEmployees.filter((emp) => emp.employeeID !== selectedEmployee.employeeID)
      );

      // Show success message
      setSnackbarMessage(`${selectedEmployee.employeeName} deleted successfully!`);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setShowDeleteModal(false);
      setSelectedEmployee(null);
    } catch (error) {
      console.error('Error deleting employee:', error);

      // Show error message
      setSnackbarMessage(
        error.response?.data?.message ||
        error.response?.data?.detail ||
        'Failed to delete employee. Please try again.'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedEmployee(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (
      formData.employeeCode &&
      formData.employeeName &&
      formData.dateOfBirth &&
      formData.dateOfJoining &&
      formData.gender &&
      formData.mobileNo &&
      formData.email &&
      formData.department &&
      formData.designation &&
      formData.country &&
      formData.state &&
      formData.city &&
      formData.maritalStatus
    ) {
      const newEmployee = {
        employeeID: employees.length + 1,
        employeeCode: formData.employeeCode,
        employeeName: formData.employeeName,
        mobileNo: formData.mobileNo,
        emailID: formData.email,
        departmentName: formData.department,
        designationName: formData.designation,
        joinDate: formData.dateOfJoining,
        dateOfBirth: formData.dateOfBirth,
        gender: formData.gender,
        alternateNo: formData.alternateNo,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        maritalStatus: formData.maritalStatus,
      };
      setEmployees([...employees, newEmployee]);
      setShowAddEmployeeModal(false);
      setSuccessModalType('add');
      setShowSuccessModal(true);
      setFormData({
        employeeCode: '',
        employeeName: '',
        dateOfBirth: '',
        dateOfJoining: '',
        gender: '',
        mobileNo: '',
        alternateNo: '',
        email: '',
        department: '',
        designation: '',
        country: '',
        state: '',
        city: '',
        maritalStatus: '',
      });
    } else {
      setSnackbarMessage('Please fill all required fields!');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (
      formData.employeeCode &&
      formData.employeeName &&
      formData.dateOfBirth &&
      formData.dateOfJoining &&
      formData.gender &&
      formData.mobileNo &&
      formData.email &&
      formData.department &&
      formData.designation &&
      formData.country &&
      formData.state &&
      formData.city &&
      formData.maritalStatus
    ) {
      const updatedEmployees = employees.map((emp) =>
        emp.employeeID === selectedEmployee.employeeID
          ? {
            ...emp,
            employeeCode: formData.employeeCode,
            employeeName: formData.employeeName,
            mobileNo: formData.mobileNo,
            emailID: formData.email,
            departmentName: formData.department,
            designationName: formData.designation,
            joinDate: formData.dateOfJoining,
            dateOfBirth: formData.dateOfBirth,
            gender: formData.gender,
            alternateNo: formData.alternateNo,
            country: formData.country,
            state: formData.state,
            city: formData.city,
            maritalStatus: formData.maritalStatus,
          }
          : emp
      );
      setEmployees(updatedEmployees);
      setShowEditEmployeeModal(false);
      setSuccessModalType('edit');
      setShowSuccessModal(true);
      setFormData({
        employeeCode: '',
        employeeName: '',
        dateOfBirth: '',
        dateOfJoining: '',
        gender: '',
        mobileNo: '',
        alternateNo: '',
        email: '',
        department: '',
        designation: '',
        country: '',
        state: '',
        city: '',
        maritalStatus: '',
      });
      setSelectedEmployee(null);
    } else {
      setSnackbarMessage('Please fill all required fields!');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleReset = () => {
    setFormData({
      employeeCode: '',
      employeeName: '',
      dateOfBirth: '',
      dateOfJoining: '',
      gender: '',
      mobileNo: '',
      alternateNo: '',
      email: '',
      department: '',
      designation: '',
      country: '',
      state: '',
      city: '',
      maritalStatus: '',
    });
  };

  const handleCancel = () => {
    setShowEditEmployeeModal(false);
    setFormData({
      employeeCode: '',
      employeeName: '',
      dateOfBirth: '',
      dateOfJoining: '',
      gender: '',
      mobileNo: '',
      alternateNo: '',
      email: '',
      department: '',
      designation: '',
      country: '',
      state: '',
      city: '',
      maritalStatus: '',
    });
    setSelectedEmployee(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };


  const getAccessToken = () =>
    localStorage.getItem('accessToken') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('token') ||
    '';

  const downloadBlob = (blobData, filename) => {
    const blob = blobData instanceof Blob
      ? blobData
      : new Blob([blobData], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const getEmployeeExportParams = () => {
    const user = getStoredUser();
    const organizationId = user?.organization_id || clientData?.id;
    const params = {};
    if (organizationId) params.organization_id = organizationId;
    if (selectedBranchId) params.branch_id = selectedBranchId;
    if (searchTerm.trim()) params.search = searchTerm.trim();
    if (exportType === 'all') params.include_inactive = true;
    return params;
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      const response = await axios.get(
        `${API_BASE_URL}/api/staff/employees/export/excel/`,
        {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
          params: getEmployeeExportParams(),
          responseType: 'blob',
        }
      );
      downloadBlob(
        response.data,
        exportType === 'active' ? 'active_employees.xlsx' : 'all_employees.xlsx'
      );
      setSnackbarMessage('Employees exported successfully');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setShowExportModal(false);
    } catch (error) {
      console.error('Employee Excel export failed:', error);
      setSnackbarMessage(
        error?.response?.data?.detail || 'Failed to export employees'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setExporting(false);
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      setDownloadingTemplate(true);
      const response = await axios.get(
        `${API_BASE_URL}/api/staff/employees/import-template/`,
        {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
          responseType: 'blob',
        }
      );
      downloadBlob(response.data, 'employee_import_template.xlsx');
      setSnackbarMessage('Employee template downloaded successfully');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Employee template download failed:', error);
      setSnackbarMessage('Failed to download employee template');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setDownloadingTemplate(false);
    }
  };

  const handleImportFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!/\.(xlsx|xls)$/i.test(file.name)) {
      setSnackbarMessage('Please select an Excel file (.xlsx or .xls)');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      event.target.value = '';
      return;
    }
    setImportFile(file);
  };

  const handleImportExcel = async () => {
    if (!importFile) {
      setSnackbarMessage('Please select an Excel file to import');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }
    try {
      setImporting(true);
      const formData = new FormData();
      formData.append('file', importFile);
      // Confirm the import endpoint and multipart field name with the backend team.
      const response = await axios.post(
        `${API_BASE_URL}/api/staff/employees/import/excel/`,
        formData,
        {
          headers: { Authorization: `Bearer ${getAccessToken()}` },
        }
      );
      setSnackbarMessage(response.data?.message || 'Employees imported successfully');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setShowImportModal(false);
      setImportFile(null);
      // Refresh the current list after a successful import.
      window.location.reload();
    } catch (error) {
      console.error('Employee Excel import failed:', error);
      const data = error?.response?.data;
      setSnackbarMessage(
        data?.message || data?.error || data?.detail || 'Failed to import employees'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setImporting(false);
    }
  };

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 1 }}>
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: theme.palette.primary.main,
                      marginLeft: 1.5,
                      fontSize: 24,
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchTerm('')}
                    sx={{
                      color: "grey",
                      marginRight: 1,
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                borderRadius: '30px',
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.15)'
                  : 'rgba(255, 255, 255, 1)',
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                  : '0 2px 8px rgba(0, 0, 0, 0.1)',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                },
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.2)'
                    : 'rgba(240, 240, 240, 1)',
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                    : '0 2px 12px rgba(0, 0, 0, 0.15)',
                },
                '&.Mui-focused': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.25)'
                    : 'rgba(255, 255, 255, 1)',
                  boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: `2px solid ${theme.palette.primary.main}`,
                  },
                },
                paddingLeft: 1.5,
                height: '50px',
                transition: 'all 0.3s ease',
              },
            }}
            sx={{
              width: 350,
              maxWidth: '100%',
              '& .MuiInputBase-input': {
                padding: '10px 14px',
                color: theme.palette.text.primary,
                fontWeight: 500,
              },
            }}
          />

          <Button
            variant="contained"
            onClick={() => { navigate("/add-employee") }}
            sx={{
              ml: 2,
              width: '160px',
              height: '50px',
              borderRadius: '10px',
              padding: '10px 0',
              fontWeight: 'bold',
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark },
            }}
            startIcon={<AddIcon />}
          >
            ADD EMPLOYEE
          </Button>
          <Tooltip title="Import Employees" arrow placement="top">
            <IconButton
              onClick={() => { setImportFile(null); setShowImportModal(true); }}
              sx={{ width: 50, height: 50, backgroundColor: theme.palette.warning.main, color: '#fff', '&:hover': { backgroundColor: theme.palette.warning.dark } }}
            >
              <FileUploadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Export Employees" arrow placement="top">
            <IconButton
              onClick={() => setShowExportModal(true)}
              sx={{ width: 50, height: 50, backgroundColor: theme.palette.info.main, color: '#fff', '&:hover': { backgroundColor: theme.palette.info.dark } }}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
          {/* <Button
            variant="outlined"

            sx={{
              ml: 2,
              width: '120px',
              borderRadius: '10px',
              height: '50px',
              padding: '10px 0',
              fontWeight: 'bold',
              borderColor: theme.palette.primary.main,
            }}

          >
            View Report
          </Button> */}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Tooltip title="User Guide">
            <IconButton
              onClick={() => setShowUserGuideModal(true)}
              sx={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                minWidth: 0, // Remove MUI's default padding
              }}
            >
              <InfoOutlineIcon sx={{ fontSize: 30 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                minWidth: 1200,
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 70, whiteSpace: 'nowrap' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Employee Code</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 180, whiteSpace: 'nowrap' }}>Employee Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150, whiteSpace: 'nowrap' }}>Mobile No.</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 200, whiteSpace: 'nowrap' }}>Email-id</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150, whiteSpace: 'nowrap' }}>Department Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150, whiteSpace: 'nowrap' }}>Designation Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150, whiteSpace: 'nowrap' }}>Date of Joining</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((employee, index) => (
                    <TableRow
                      key={employee.employeeID}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.employeeCode}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.employeeName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.mobileNo}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.emailID}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.departmentName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.designationName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{employee.joinDate}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="Edit Employee">
                          <IconButton
                            onClick={() => navigate(`/edit-employee/${employee.employeeID}`)}
                            sx={{
                              color: theme.palette.primary.light,
                              '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                              },
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Employee">
                          <IconButton
                            color="error"
                            onClick={() => handleShowDeleteModal(employee)}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                              },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}>
                    <TableCell colSpan={9} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


      {/* Import Employees Modal - same layout as Admission */}
      <Modal
        open={showImportModal}
        onClose={() => { if (!importing) { setShowImportModal(false); setImportFile(null); } }}
        BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.8)' } }}
      >
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 480, maxWidth: '90vw', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden', maxHeight: '90vh' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>Import Employees</Typography>
            <IconButton onClick={() => { setShowImportModal(false); setImportFile(null); }} disabled={importing} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
          </Box>
          <Box sx={{ padding: '20px', overflowY: 'auto', maxHeight: 'calc(90vh - 60px)' }}>
            <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Step 1: Download the template</Typography>
            <Button variant="outlined" startIcon={downloadingTemplate ? <CircularProgress size={18} /> : <DownloadIcon />} onClick={handleDownloadTemplate} disabled={downloadingTemplate} sx={{ mb: 3 }}>
              {downloadingTemplate ? 'Downloading...' : 'Download Template'}
            </Button>
            <Typography sx={{ fontWeight: 'bold', mb: 0.5 }}>Step 2: Enter data in the proper format</Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>Fill in the employee details in the downloaded Excel file. Keep the template column headings unchanged. Related fields should contain IDs. Employee code is generated by the server.</Typography>
            <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Step 3: Choose the Excel file</Typography>
            <Button variant="contained" component="label" sx={{ mb: 1 }} disabled={importing}>
              Select File
              <input type="file" hidden accept=".xlsx,.xls" onChange={handleImportFileChange} onClick={(event) => { event.target.value = null; }} />
            </Button>
            {importFile && <Typography variant="body2" sx={{ mb: 1, overflowWrap: 'anywhere' }}>Selected: {importFile.name}</Typography>}
            <Typography sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>Step 4: Click Import</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Button variant="outlined" color="error" onClick={() => { setShowImportModal(false); setImportFile(null); }} disabled={importing} data-app-cancel="true">Cancel</Button>
              <Button variant="contained" onClick={handleImportExcel} disabled={!importFile || importing} startIcon={importing ? <CircularProgress size={18} color="inherit" /> : null}>
                {importing ? 'Importing...' : 'Import'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Export Employees Modal - same layout as Admission */}
      <Modal open={showExportModal} onClose={() => { if (!exporting) setShowExportModal(false); }} BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, maxWidth: '90vw', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>Export Employees</Typography>
            <IconButton onClick={() => setShowExportModal(false)} disabled={exporting} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography sx={{ mb: 1, fontWeight: 'bold' }}>Which employees do you want to export?</Typography>
            <RadioGroup value={exportType} onChange={(event) => setExportType(event.target.value)}>
              <FormControlLabel value="active" control={<Radio />} label="Active records only" />
              <FormControlLabel value="all" control={<Radio />} label="All records (active + inactive)" />
            </RadioGroup>
            <Typography variant="body2" sx={{ mt: 1, color: 'text.primary' }}>The current organization, selected branch, and other supported filters will be applied.</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
              <Button variant="outlined" color="error" onClick={() => setShowExportModal(false)} disabled={exporting} data-app-cancel="true">Cancel</Button>
              <Button variant="contained" onClick={handleExportExcel} disabled={exporting} startIcon={exporting ? <CircularProgress size={18} color="inherit" /> : <FileDownloadIcon />}>
                {exporting ? 'Exporting...' : 'Export'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Delete Modal */}
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete <strong>{selectedEmployee?.employeeName}</strong>?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>


      {/* Add Employee Modal */}
      <Modal
        open={showAddEmployeeModal}
        onClose={() => setShowAddEmployeeModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Employee
            </Typography>
            <IconButton onClick={() => setShowAddEmployeeModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px', overflowY: 'auto', flexGrow: 1 }}>
            <form onSubmit={handleSave}>
              <Button variant="contained" component="label" sx={{ mb: 3 }}>
                Upload Image
                <input type="file" hidden />
              </Button>
              <TextField
                label="Employee Code"
                variant="outlined"
                fullWidth
                name="employeeCode"
                value={formData.employeeCode}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Employee Name"
                variant="outlined"
                fullWidth
                name="employeeName"
                value={formData.employeeName}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Date of Birth"
                type="date"
                variant="outlined"
                fullWidth
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Date of Joining"
                type="date"
                variant="outlined"
                fullWidth
                name="dateOfJoining"
                value={formData.dateOfJoining}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <FormControl component="fieldset" sx={{ mb: 3 }}>
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>
                  Gender
                </Typography>
                <RadioGroup row name="gender" value={formData.gender} onChange={handleChange}>
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                </RadioGroup>
              </FormControl>
              <TextField
                type="tel"
                inputProps={{ maxLength: 10 }}
                label="Mobile No."
                variant="outlined"
                fullWidth
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                type="tel"
                inputProps={{ maxLength: 10 }}
                label="Alternate No."
                variant="outlined"
                fullWidth
                name="alternateNo"
                value={formData.alternateNo}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="department-label" sx={{ color: theme.palette.text.primary }}>
                  Department
                </InputLabel>
                <Select
                  labelId="department-label"
                  id="department"
                  name="department"
                  value={formData.department}
                  label="Department"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticDepartmentData.map((department) => (
                    <MenuItem key={department.departmentId} value={department.departmentName}>
                      {department.departmentName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="designation-label" sx={{ color: theme.palette.text.primary }}>
                  Designation
                </InputLabel>
                <Select
                  labelId="designation-label"
                  id="designation"
                  name="designation"
                  value={formData.designation}
                  label="Designation"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticDesignationData.map((designation) => (
                    <MenuItem key={designation.designationId} value={designation.designationName}>
                      {designation.designationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="country-label" sx={{ color: theme.palette.text.primary }}>
                  Country
                </InputLabel>
                <Select
                  labelId="country-label"
                  id="country"
                  name="country"
                  value={formData.country}
                  label="Country"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticCountryData.map((country) => (
                    <MenuItem key={country.countryId} value={country.countryName}>
                      {country.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="state-label" sx={{ color: theme.palette.text.primary }}>
                  State
                </InputLabel>
                <Select
                  labelId="state-label"
                  id="state"
                  name="state"
                  value={formData.state}
                  label="State"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticStateData.map((state) => (
                    <MenuItem key={state.stateId} value={state.stateName}>
                      {state.stateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="city-label" sx={{ color: theme.palette.text.primary }}>
                  City
                </InputLabel>
                <Select
                  labelId="city-label"
                  id="city"
                  name="city"
                  value={formData.city}
                  label="City"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticCityData.map((city) => (
                    <MenuItem key={city.cityId} value={city.cityName}>
                      {city.cityName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="maritalStatus-label" sx={{ color: theme.palette.text.primary }}>
                  Marital Status
                </InputLabel>
                <Select
                  labelId="maritalStatus-label"
                  id="maritalStatus"
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  label="Marital Status"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticMaritalStatusData.map((status) => (
                    <MenuItem key={status.statusId} value={status.statusName}>
                      {status.statusName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button variant="contained" component="label" sx={{ mb: 3 }}>
                Upload Resume
                <input type="file" hidden />
              </Button>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Tooltip
                  title={
                    !formData.employeeCode ? 'Enter Employee Code' :
                      !formData.employeeName ? 'Enter Employee Name' :
                        !formData.dateOfBirth ? 'Enter Date of Birth' :
                          !formData.dateOfJoining ? 'Enter Date of Joining' :
                            !formData.gender ? 'Select Gender' :
                              !formData.mobileNo ? 'Enter Mobile No.' :
                                !formData.email ? 'Enter Email' :
                                  !formData.department ? 'Select Department' :
                                    !formData.designation ? 'Select Designation' :
                                      !formData.country ? 'Select Country' :
                                        !formData.state ? 'Select State' :
                                          !formData.city ? 'Select City' :
                                            !formData.maritalStatus ? 'Select Marital Status' : ''
                  }
                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      onClick={handleSave}
                      sx={{
                        mr: 2,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.dark },
                      }}
                      disabled={
                        !formData.employeeCode ||
                        !formData.employeeName ||
                        !formData.dateOfBirth ||
                        !formData.dateOfJoining ||
                        !formData.gender ||
                        !formData.mobileNo ||
                        !formData.email ||
                        !formData.department ||
                        !formData.designation ||
                        !formData.country ||
                        !formData.state ||
                        !formData.city ||
                        !formData.maritalStatus
                      }
                    >
                      SAVE
                    </Button>
                  </span>
                </Tooltip>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                >
                  RESET
                </Button>
              </Box>
            </form>
          </Box>
        </CustomTableScrollbar>
      </Modal>


      {/* Edit Employee Modal */}
      <Modal
        open={showEditEmployeeModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Employee
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px', overflowY: 'auto', flexGrow: 1 }}>
            <form onSubmit={handleUpdate}>
              <Button variant="contained" component="label" sx={{ mb: 3 }}>
                Upload Image
                <input type="file" hidden />
              </Button>
              <TextField
                label="Employee Code"
                variant="outlined"
                fullWidth
                name="employeeCode"
                value={formData.employeeCode}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Employee Name"
                variant="outlined"
                fullWidth
                name="employeeName"
                value={formData.employeeName}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Date of Birth"
                type="date"
                variant="outlined"
                fullWidth
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Date of Joining"
                type="date"
                variant="outlined"
                fullWidth
                name="dateOfJoining"
                value={formData.dateOfJoining}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <FormControl component="fieldset" sx={{ mb: 3 }}>
                <Typography component="legend" sx={{ color: theme.palette.text.primary }}>
                  Gender
                </Typography>
                <RadioGroup row name="gender" value={formData.gender} onChange={handleChange}>
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                </RadioGroup>
              </FormControl>
              <TextField
                type="tel"
                inputProps={{ maxLength: 10 }}
                label="Mobile No."
                variant="outlined"
                fullWidth
                name="mobileNo"
                value={formData.mobileNo}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                type="tel"
                inputProps={{ maxLength: 10 }}
                label="Alternate No."
                variant="outlined"
                fullWidth
                name="alternateNo"
                value={formData.alternateNo}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                sx={{
                  mb: 3,
                  '& .MuiInputLabel-root': {
                    color: theme.palette.text.primary,
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              />
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="department-label" sx={{ color: theme.palette.text.primary }}>
                  Department
                </InputLabel>
                <Select
                  labelId="department-label"
                  id="department"
                  name="department"
                  value={formData.department}
                  label="Department"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticDepartmentData.map((department) => (
                    <MenuItem key={department.departmentId} value={department.departmentName}>
                      {department.departmentName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="designation-label" sx={{ color: theme.palette.text.primary }}>
                  Designation
                </InputLabel>
                <Select
                  labelId="designation-label"
                  id="designation"
                  name="designation"
                  value={formData.designation}
                  label="Designation"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticDesignationData.map((designation) => (
                    <MenuItem key={designation.designationId} value={designation.designationName}>
                      {designation.designationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="country-label" sx={{ color: theme.palette.text.primary }}>
                  Country
                </InputLabel>
                <Select
                  labelId="country-label"
                  id="country"
                  name="country"
                  value={formData.country}
                  label="Country"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticCountryData.map((country) => (
                    <MenuItem key={country.countryId} value={country.countryName}>
                      {country.countryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="state-label" sx={{ color: theme.palette.text.primary }}>
                  State
                </InputLabel>
                <Select
                  labelId="state-label"
                  id="state"
                  name="state"
                  value={formData.state}
                  label="State"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticStateData.map((state) => (
                    <MenuItem key={state.stateId} value={state.stateName}>
                      {state.stateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="city-label" sx={{ color: theme.palette.text.primary }}>
                  City
                </InputLabel>
                <Select
                  labelId="city-label"
                  id="city"
                  name="city"
                  value={formData.city}
                  label="City"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticCityData.map((city) => (
                    <MenuItem key={city.cityId} value={city.cityName}>
                      {city.cityName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="maritalStatus-label" sx={{ color: theme.palette.text.primary }}>
                  Marital Status
                </InputLabel>
                <Select
                  labelId="maritalStatus-label"
                  id="maritalStatus"
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  label="Marital Status"
                  onChange={handleChange}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                >
                  {staticMaritalStatusData.map((status) => (
                    <MenuItem key={status.statusId} value={status.statusName}>
                      {status.statusName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button variant="contained" component="label" sx={{ mb: 3 }}>
                Upload Resume
                <input type="file" hidden />
              </Button>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Tooltip
                  title={
                    !formData.employeeCode ? 'Enter Employee Code' :
                      !formData.employeeName ? 'Enter Employee Name' :
                        !formData.dateOfBirth ? 'Enter Date of Birth' :
                          !formData.dateOfJoining ? 'Enter Date of Joining' :
                            !formData.gender ? 'Select Gender' :
                              !formData.mobileNo ? 'Enter Mobile No.' :
                                !formData.email ? 'Enter Email' :
                                  !formData.department ? 'Select Department' :
                                    !formData.designation ? 'Select Designation' :
                                      !formData.country ? 'Select Country' :
                                        !formData.state ? 'Select State' :
                                          !formData.city ? 'Select City' :
                                            !formData.maritalStatus ? 'Select Marital Status' : ''
                  }
                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      onClick={handleUpdate}
                      sx={{
                        mr: 2,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.dark },
                      }}
                      disabled={
                        !formData.employeeCode ||
                        !formData.employeeName ||
                        !formData.dateOfBirth ||
                        !formData.dateOfJoining ||
                        !formData.gender ||
                        !formData.mobileNo ||
                        !formData.email ||
                        !formData.department ||
                        !formData.designation ||
                        !formData.country ||
                        !formData.state ||
                        !formData.city ||
                        !formData.maritalStatus
                      }
                    >
                      UPDATE
                    </Button>
                  </span>
                </Tooltip>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCancel}
                >
                  CANCEL
                </Button>
              </Box>
            </form>
          </Box>
        </CustomTableScrollbar>
      </Modal>


      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Employee Module - For The User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
          <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
            {/* Section 1: Add Employee */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
            >
              ➤ Follow the steps below to add a new employee:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Click the <strong>ADD EMPLOYEE</strong> button at the top right to open the employee form.</li>
              <li>Alternatively, use the add modal if implemented: Fill in all required fields, including Employee Code, Employee Name, Date of Birth, Date of Joining, Gender, Mobile No., Email, Department, Designation, Country, State, City, and Marital Status.</li>
              <li>Optionally, upload an image or resume using the provided upload buttons.</li>
              <li>Select the appropriate options from dropdowns for Department, Designation, Country, State, City, and Marital Status.</li>
              <li>Enter additional details, such as Alternate No., if applicable.</li>
              <li>Review all information for accuracy before submission.</li>
              <li>Click <strong>SAVE</strong> to add the employee. A success message will confirm the addition.</li>
              <li>The new employee will appear in the Employee List table.</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: All required fields must be completed. Mobile numbers must be 10 digits.
            </Typography>

            {/* Section 2: Edit Employee */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
              ➤ Follow these steps to edit an existing employee:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Select the employee from the Employee List table.</li>
              <li>Click the <strong>Edit</strong> (pencil icon) in the Action column to open the edit form.</li>
              <li>Update the necessary fields, ensuring all required fields are completed.</li>
              <li>Optionally, upload a new image or resume.</li>
              <li>Click <strong>UPDATE</strong> to save changes. A success message will confirm the update.</li>
              <li>Click <strong>CANCEL</strong> to discard changes and close the form.</li>
              <li>Double-check all updates before saving.</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: Ensure all mandatory fields are filled to avoid errors.
            </Typography>

            {/* Section 3: Delete Employee */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
              ➤ Follow these steps to delete an employee:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Select the employee from the Employee List table.</li>
              <li>Click the <strong>Delete</strong> (trash icon) in the Action column.</li>
              <li>Confirm deletion in the modal by clicking <strong>Yes, Delete</strong>.</li>
              <li>The employee record will be removed, and a success message will appear.</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: Deleted employees cannot be recovered. Proceed with caution.
            </Typography>

            {/* Section 4: Search Employees */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
              ➤ Follow these steps to search for an employee:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Use the search bar at the top left of the Employee List.</li>
              <li>Enter the employee's name, department, or designation to filter the table.</li>
              <li>The table will update automatically to show matching results.</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: Search is case-insensitive and filters by Employee Name, Department, or Designation.
            </Typography>

            {/* Section 5: View Report */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
              ➤ Follow these steps to view the employee report:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Click the <strong>View Report</strong> button at the top of the page.</li>
              <li>The report will generate based on the current employee data.</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: Ensure all data is up-to-date before generating the report.
            </Typography>

            {/* Section 6: Pagination */}
            <Typography
              variant="body1"
              sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
            >
              ➤ Follow these steps to navigate the employee list:
            </Typography>
            <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
              <li>Use the pagination controls at the bottom to browse pages.</li>
              <li>Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to switch pages.</li>
              <li>Select a specific page number by clicking on it.</li>
              <li>Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).</li>
            </ul>
            <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
              ⚠️ Note: The table displays only the selected number of rows per page.
            </Typography>

            {/* Bottom Close Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            </Box>
          </CustomTableScrollbar>
        </Box>
      </Modal>
    </Container>
  );
};

export default Employee;